import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import Sortable from "sortablejs"

// Drag-to-reorder. Children carry data-id; the new order is PATCHed as ids[] and the page is refreshed.
// The up/down buttons stay as the no-JS / keyboard fallback; drag handles are hidden until this runs.
export default class extends Controller {
  static values = { url: String, handle: { type: String, default: ".drag-handle" } }

  connect() {
    this.element.querySelectorAll(this.handleValue).forEach((el) => el.classList.remove("hidden"))
    // Dragging a section re-inserts it, which makes Stimulus disconnect/reconnect the item lists inside it.
    // Re-use the existing Sortable then; destroying it would abort the drag in progress.
    this.sortable = Sortable.get(this.element) || Sortable.create(this.element, {
      handle: this.handleValue,
      draggable: "[data-id]",
      animation: 150,
      onEnd: () => this.save()
    })
  }

  disconnect() {
    setTimeout(() => {
      if (!this.element.isConnected) Sortable.get(this.element)?.destroy()
    }, 0)
  }

  async save() {
    const body = new URLSearchParams()
    this.element.querySelectorAll(":scope > [data-id]").forEach((el) => body.append("ids[]", el.dataset.id))
    const token = document.querySelector("meta[name=csrf-token]")?.content
    const response = await fetch(this.element.dataset.sortableUrlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token, Accept: "text/plain" },
      body
    })
    Turbo.session.refresh(window.location.href)
    if (!response.ok) console.error("Reorder failed", response.status)
  }
}
